import { getOperatorName } from "./getOperatorName";
import { useState, useEffect } from "react";

/**
 * Lista de operadores que têm acesso ao fluxo de encomendas (EmbarcaLog)
 */
const getEnabledOperators = (): string[] => {
  if (typeof window === "undefined") return [];

  const envOperators =
    process.env.NEXT_PUBLIC_EMBARCA_LOG_ENABLED_OPERATORS || "";
  return envOperators
    .split(",")
    .map((operator) => operator.trim())
    .filter(Boolean);
};

const ENABLED_OPERATORS = getEnabledOperators();

/**
 * Valida se o operador atual tem acesso ao fluxo de encomendas
 * @param redirectUrl URL para redirecionar se não tiver acesso (padrão: "/")
 * @returns true se tiver acesso, false caso contrário
 */
export const validateEmbarcaLogAccess = (
  _redirectUrl: string = "/"
): boolean => {
  // App standalone do Embarca Log: acesso sempre liberado (sem allowlist/redirect).
  return true;
};

/**
 * Hook para validar acesso ao EmbarcaLog em componentes React
 * @param redirectUrl URL para redirecionar se não tiver acesso (padrão: "/")
 * @returns true se tiver acesso, false caso contrário
 */
export const useEmbarcaLogValidation = (
  _redirectUrl: string = "/"
): boolean => {
  // App standalone do Embarca Log: acesso sempre liberado (sem allowlist/redirect).
  return true;
};

/**
 * Middleware para validar acesso ao EmbarcaLog em páginas Next.js
 * Deve ser usado em getServerSideProps ou middleware
 */
export const validateEmbarcaLogMiddleware = (context: any) => {
  const { req } = context;
  const host = req.headers.host || "";
  const operator = host.split(".")[0];

  if (!ENABLED_OPERATORS.includes(operator)) {
    return {
      redirect: {
        destination: "/",
        permanent: false,
      },
    };
  }

  return null;
};

/**
 * Verifica se o operador atual tem acesso ao EmbarcaLog (sem redirecionamento)
 * @returns true se tiver acesso, false caso contrário
 */
export const hasEmbarcaLogAccess = (): boolean => {
  // App standalone do Embarca Log: sempre habilitado.
  return true;
};
